interface MoroccanLoaderProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
}

export default function MoroccanLoader({ message = 'Loading...', size = 'md' }: MoroccanLoaderProps) {
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32'
  }

  // The pentagram (interlaced five-pointed star) for the Moroccan flag
  // This draws the star as 5 connected line segments that cross over each other
  const starPath = "M50 5 L80.45 93.55 L2.45 38.2 L97.55 38.2 L19.55 93.55 Z"

  return (
    <div className="flex flex-col justify-center items-center h-64 gap-4">
      <div className={`relative ${sizeClasses[size]}`}>
        <svg
          viewBox="0 0 100 100"
          className="w-full h-full overflow-visible"
        >
          <defs>
            {/* Clip path for the red background that animates from bottom to top */}
            <clipPath id="redBgClip">
              <rect
                x="-10"
                y="-10"
                width="120"
                height="120"
                className="animate-fill-up"
              />
            </clipPath>
          </defs>

          {/* Red background that fills from bottom to top */}
          <g clipPath="url(#redBgClip)">
            <rect
              x="-5"
              y="-5"
              width="110"
              height="110"
              rx="8"
              fill="#C1272D"
              className="animate-fade-in-delayed"
              style={{ opacity: 0 }}
            />
          </g>

          {/* Green stroke star that draws itself */}
          <path
            d={starPath}
            fill="none"
            stroke="#006233"
            strokeWidth="4"
            strokeLinejoin="miter"
            className="animate-draw-star"
            style={{
              strokeDasharray: 550,
              strokeDashoffset: 550,
            }}
          />
        </svg>
      </div>

      <p className="text-slate-600 font-medium">
        {message}
      </p>

      <style>{`
        @keyframes drawStar {
          0% {
            stroke-dashoffset: 550;
          }
          50% {
            stroke-dashoffset: 0;
          }
          100% {
            stroke-dashoffset: 0;
          }
        }

        @keyframes fillUp {
          0%, 45% {
            transform: translateY(120px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @keyframes fadeInDelayed {
          0%, 45% {
            opacity: 0;
          }
          46% {
            opacity: 1;
          }
          100% {
            opacity: 1;
          }
        }

        .animate-draw-star {
          animation: drawStar 2.5s ease-in-out infinite;
        }

        .animate-fill-up {
          animation: fillUp 2.5s ease-out infinite;
        }

        .animate-fade-in-delayed {
          animation: fadeInDelayed 2.5s ease-out infinite;
        }
      `}</style>
    </div>
  )
}
